import NavigationService from "@utils/NavigationService";

export default () => {
  let data = NavigationService._navigator.current?.getRootState();
  while (data?.routes || data.state?.routes) {
    const routes = data?.routes || data.state?.routes;
    if (routes) {
      data = routes[routes.length - 1];
    }
  }
  return { name: data?.name || "", params: data?.params || "" };
};
